const PermissionsConfig = {
  tabs: {
    live: {
      read: {
        strategy: "atLeastOne",
        perms: ["tabs.live"],
      },
    },
    park_stats: {
      read: {
        strategy: "atLeastOne",
        perms: ["tabs.park_stats"],
      },
    },
    pedestrian_stats: {
      read: {
        strategy: "atLeastOne",
        perms: ["tabs.pedestrian_stats"],
      },
    },
    nonMovingCars: {
      read: {
        strategy: "atLeastOne",
        perms: ["tabs.park_non_moving_cars"],
      },
    },
    analysis: {
      read: {
        strategy: "atLeastOne",
        perms: ["tabs.analysis"],
      },
    },
    flow: {
      read: {
        strategy: "atLeastOne",
        perms: ["tabs.flow"],
      },
    },
    customAnalysis: {
      read: {
        strategy: "atLeastOne",
        perms: ["tabs.custom_analysis"],
      },
    },
    indicators: {
      read: {
        strategy: "atLeastOne",
        perms: ["tabs.indicators"],
      },
    },
    visitorCharacteristics: {
      read: {
        strategy: "atLeastOne",
        perms: ["tabs.visitor_characteristics"],
      },
    },
    config: {
      read: {
        strategy: "atLeastOne",
        perms: [
          "tabs.config_sectors",
          "tabs.config_displays",
          "tabs.config_gates",
        ],
      },
    },
    config_sectors: {
      read: {
        strategy: "atLeastOne",
        perms: ["tabs.config_sectors"],
      },
    },
    config_displays: {
      read: {
        strategy: "atLeastOne",
        perms: ["tabs.config_displays"],
      },
    },
    config_gates: {
      read: {
        strategy: "atLeastOne",
        perms: ["tabs.config_gates"],
      },
    },
    alerts: {
      read: {
        strategy: "atLeastOne",
        perms: ["tabs.alerts"],
      },
    },
    "alerts.config_outputs": {
      read: {
        strategy: "atLeastOne",
        perms: ["tabs.alerts.config_outputs"],
      },
    },
  },
  park_stats: {
    areasSelection: {
      read: {
        strategy: "allOf",
        perms: ["tabs.park_stats", "park_stats.areas_selection"],
      },
    },
    general: {
      read: {
        strategy: "allOf",
        perms: ["tabs.park_stats", "park_stats.general"],
      },
    },
    "general.carsParked": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.park_stats",
          "park_stats.general",
          "park_stats.general.cars_parked",
        ],
      },
    },
    "general.carsParked.avg": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.park_stats",
          "park_stats.general",
          "park_stats.general.cars_parked",
          "park_stats.general.cars_parked.avg",
        ],
      },
    },
    "general.availableSpots": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.park_stats",
          "park_stats.general",
          "park_stats.general.available_spots",
        ],
      },
    },
    "general.availableSpots.avg": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.park_stats",
          "park_stats.general",
          "park_stats.general.available_spots",
          "park_stats.general.available_spots.avg",
        ],
      },
    },
    "general.carsParkedAverageDuration": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.park_stats",
          "park_stats.general",
          "park_stats.general.cars_parked_avg_duration",
        ],
      },
    },
    "general.carsParkedAverageDuration.avg": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.park_stats",
          "park_stats.general",
          "park_stats.general.cars_parked_avg_duration",
          "park_stats.general.cars_parked_avg_duration.avg",
        ],
      },
    },
    keys: {
      read: {
        strategy: "allOf",
        perms: ["tabs.park_stats", "park_stats.keys"],
      },
    },
    "keys.pressure": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.park_stats",
          "park_stats.keys",
          "park_stats.keys.pressure",
        ],
      },
    },
    "keys.flow": {
      read: {
        strategy: "allOf",
        perms: ["tabs.park_stats", "park_stats.keys", "park_stats.keys.flow"],
      },
    },
    controls: {
      read: {
        strategy: "allOf",
        perms: ["tabs.park_stats", "park_stats.controls"],
      },
    },
    "controls.infractions": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.park_stats",
          "park_stats.controls",
          "park_stats.controls.infractions",
        ],
      },
    },
    "controls.infractions.avg": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.park_stats",
          "park_stats.controls",
          "park_stats.controls.infractions",
          "park_stats.controls.infractions.avg",
        ],
      },
    },
    "controls.obstructiveParking": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.park_stats",
          "park_stats.controls",
          "park_stats.controls.obstructive_parking",
        ],
      },
    },
    "controls.obstructiveParking.avg": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.park_stats",
          "park_stats.controls",
          "park_stats.controls.obstructive_parking",
          "park_stats.controls.obstructive_parking.avg",
        ],
      },
    },
    "controls.nonMoving": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.park_stats",
          "park_stats.controls",
          "park_stats.controls.non_moving",
        ],
      },
    },
    "controls.nonMoving.avg": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.park_stats",
          "park_stats.controls",
          "park_stats.controls.non_moving",
          "park_stats.controls.non_moving.avg",
        ],
      },
    },
    dailyAttendance: {
      read: {
        strategy: "allOf",
        perms: ["tabs.park_stats", "park_stats.daily_attendance"],
      },
    },
    displayCircles: {
      read: {
        strategy: "allOf",
        perms: ["map.display_circles"],
      },
    },
  },
  pedestrian_stats: {
    "queue.details": {
      read: {
        strategy: "allOf",
        perms: ["pedestrian_stats.queue.details"],
      },
    },
    "queue.dailyAttendance": {
      read: {
        strategy: "allOf",
        perms: ["pedestrian_stats.queue.graph.daily_attendance"],
      },
    },
    "queue.dailyAttendanceMax": {
      read: {
        strategy: "allOf",
        perms: ["pedestrian_stats.queue.graph.daily_attendance_max"],
      },
    },
    "queue.dailyWaitingTime": {
      read: {
        strategy: "allOf",
        perms: ["pedestrian_stats.queue.graph.daily_waiting"],
      },
    },
    areasSelection: {
      read: {
        strategy: "allOf",
        perms: ["tabs.pedestrian_stats", "pedestrian_stats.areas_selection"],
      },
    },
    keys: {
      read: {
        strategy: "allOf",
        perms: ["tabs.pedestrian_stats", "pedestrian_stats.keys"],
      },
    },
    "keys.visitorsCounter": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.pedestrian_stats",
          "pedestrian_stats.keys",
          "pedestrian_stats.keys.visitors_counter",
        ],
      },
    },
    "keys.visitorsCounter.avg": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.pedestrian_stats",
          "pedestrian_stats.keys",
          "pedestrian_stats.keys.visitors_counter",
          "pedestrian_stats.keys.visitors_counter.avg",
        ],
      },
    },
    "keys.flow": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.pedestrian_stats",
          "pedestrian_stats.keys",
          "pedestrian_stats.keys.flow",
        ],
      },
    },
    attendance: {
      read: {
        strategy: "allOf",
        perms: ["tabs.pedestrian_stats", "pedestrian_stats.attendance"],
      },
    },
    "attendance.threshold": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.pedestrian_stats",
          "pedestrian_stats.attendance",
          "pedestrian_stats.attendance.threshold",
        ],
      },
    },
    dailyAttendance: {
      read: {
        strategy: "allOf",
        perms: ["tabs.pedestrian_stats", "pedestrian_stats.daily_attendance"],
      },
    },
  },
  map: {
    currentDate: {
      read: {
        strategy: "allOf",
        perms: ["map.current_date"],
      },
    },
    duration: {
      read: {
        strategy: "allOf",
        perms: ["map.duration"],
      },
    },
    areaType: {
      read: {
        strategy: "allOf",
        perms: ["map.meta_data.area.type"],
      },
    },
    availableFrom: {
      read: {
        strategy: "allOf",
        perms: ["map.available_from"],
      },
    },
    availableTo: {
      read: {
        strategy: "allOf",
        perms: ["map.available_to"],
      },
    },
    arrivalTime: {
      read: {
        strategy: "allOf",
        perms: ["map.arrival_time"],
      },
    },
    leavingTime: {
      read: {
        strategy: "allOf",
        perms: ["map.leaving_time"],
      },
    },
    totalDuration: {
      read: {
        strategy: "allOf",
        perms: ["map.total_duration"],
      },
    },
    size: {
      read: {
        strategy: "allOf",
        perms: ["map.size"],
      },
    },
    lockSpaces: {
      read: {
        strategy: "allOf",
        perms: ["map.lock_spaces"],
      },
    },
  },
  flow: {
    keys: {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.keys"],
      },
    },
    "keys.in": {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.keys", "flow.keys.in"],
      },
    },
    "keys.out": {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.keys", "flow.keys.out"],
      },
    },
    "keys.in.max": {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.keys", "flow.keys.in.max"],
      },
    },
    "keys.out.max": {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.keys", "flow.keys.out.max"],
      },
    },
    distributionArea: {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.distribution_area"],
      },
    },
    "paths.keys": {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.paths.keys"],
      },
    },
    "paths.keys.number_of_passages": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.flow",
          "flow.paths.keys",
          "flow.paths.keys.number_of_passages",
        ],
      },
    },
    "paths.keys.travel_time_avg": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.flow",
          "flow.paths.keys",
          "flow.paths.keys.travel_time_avg",
        ],
      },
    },
    "paths.keys.travel_time_median": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.flow",
          "flow.paths.keys",
          "flow.paths.keys.travel_time_median",
        ],
      },
    },
    "paths.keys.travel_speed_avg": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.flow",
          "flow.paths.keys",
          "flow.paths.keys.travel_speed_avg",
        ],
      },
    },
    "paths.distribution": {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.paths.distribution"],
      },
    },
    "paths.graph_travel_time": {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.paths.graph_travel_time"],
      },
    },
    distributionPoint: {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.distribution_point"],
      },
    },
    "distributionPoint.percentageBar": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.flow",
          "flow.distribution_point",
          "flow.distribution_point.percentage_bar",
        ],
      },
    },
    "distributionPoint.threshold": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.flow",
          "flow.distribution_point",
          "flow.distribution_point.threshold",
        ],
      },
    },
    chronologyArea: {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.chronology_area"],
      },
    },
    chronologyPoint: {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.chronology_point"],
      },
    },
    categoryCountArea: {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.category_count_area"],
      },
    },
    categoryCountPoint: {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.category_count_point"],
      },
    },
    numberOfCountsArea: {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.number_of_counts_area"],
      },
    },
    numberOfCountsPoint: {
      read: {
        strategy: "allOf",
        perms: ["tabs.flow", "flow.number_of_counts_point"],
      },
    },
  },
  customAnalysis: {
    dowAttendance: {
      read: {
        strategy: "allOf",
        perms: ["tabs.custom_analysis", "custom_analysis.dow_attendance"],
      },
    },
    dowPressure: {
      read: {
        strategy: "allOf",
        perms: ["tabs.custom_analysis", "custom_analysis.dow_pressure"],
      },
    },
    attendance: {
      read: {
        strategy: "allOf",
        perms: ["tabs.custom_analysis", "custom_analysis.attendance"],
      },
    },
    attendancePeak: {
      read: {
        strategy: "allOf",
        perms: ["tabs.custom_analysis", "custom_analysis.attendance_peak"],
      },
    },
    hourlyAttendance: {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.custom_analysis",
          "custom_analysis.hourly_parked_duration",
        ],
      },
    },
    attendanceStats: {
      read: {
        strategy: "allOf",
        perms: ["tabs.custom_analysis", "custom_analysis.attendance_stats"],
      },
    },
    "attendanceStats.avgAttendance": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.custom_analysis",
          "custom_analysis.attendance_stats",
          "custom_analysis.attendance_stats.avg_attendance",
        ],
      },
    },
    "attendanceStats.recordAttendance": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.custom_analysis",
          "custom_analysis.attendance_stats",
          "custom_analysis.attendance_stats.record_attendance",
        ],
      },
    },
    "attendanceStats.recordPeakAttendance": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.custom_analysis",
          "custom_analysis.attendance_stats",
          "custom_analysis.attendance_stats.record_peak_attendance",
        ],
      },
    },
  },
  indicators: {
    map: {
      read: {
        strategy: "allOf",
        perms: ["tabs.indicators", "indicators.map"],
      },
    },
    attendance: {
      read: {
        strategy: "allOf",
        perms: ["tabs.indicators", "indicators.attendance"],
      },
    },
    turnover: {
      read: {
        strategy: "allOf",
        perms: ["tabs.indicators", "indicators.turnover"],
      },
    },
    averageDuration: {
      read: {
        strategy: "allOf",
        perms: ["tabs.indicators", "indicators.average_duration"],
      },
    },
    saturationTime: {
      read: {
        strategy: "allOf",
        perms: ["tabs.indicators", "indicators.saturation_time"],
      },
    },
    nonMovingCars: {
      read: {
        strategy: "allOf",
        perms: ["tabs.indicators", "indicators.non_moving_cars"],
      },
    },
    nonMovingTime: {
      read: {
        strategy: "allOf",
        perms: ["tabs.indicators", "indicators.non_moving_time"],
      },
    },
    pedestrianCarRatio: {
      read: {
        strategy: "allOf",
        perms: ["tabs.indicators", "indicators.pedestrian_car_ratio"],
      },
    },
    footfallTotal: {
      read: {
        strategy: "allOf",
        perms: ["tabs.indicators", "indicators.footfall_total"],
      },
    },
    revenueTotal: {
      read: {
        strategy: "allOf",
        perms: ["tabs.indicators", "indicators.revenue_total"],
      },
    },
    revenueLoss: {
      read: {
        strategy: "allOf",
        perms: ["tabs.indicators", "indicators.revenue_loss"],
      },
    },
    parkingGrade: {
      read: {
        strategy: "allOf",
        perms: ["tabs.indicators", "indicators.parking_grade"],
      },
    },
    capacity: {
      read: {
        strategy: "allOf",
        perms: ["tabs.indicators", "indicators.capacity"],
      },
    },
  },
  visitorCharacteristics: {
    visitorStats: {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.visitor_characteristics",
          "visitor_characteristics.visitor_stats",
        ],
      },
    },
    visitorDistribution: {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.visitor_characteristics",
          "visitor_characteristics.visitor_distribution",
        ],
      },
    },
    parkingTimeDistribution: {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.visitor_characteristics",
          "visitor_characteristics.parking_time_distribution",
        ],
      },
    },
    mapAppDistribution: {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.visitor_characteristics",
          "visitor_characteristics.map_app_distribution",
        ],
      },
    },
    fullMapAppDistribution: {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.visitor_characteristics",
          "visitor_characteristics.full_map_app_distribution",
        ],
      },
    },
    destinationsDistribution: {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.visitor_characteristics",
          "visitor_characteristics.destinations_distribution",
        ],
      },
    },
  },
  config_gates: {
    automaticSystems: {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.config_gates",
          "tabs.config_gates.automatic_systems",
          "tabs.config_gates.automatic_systems.gate",
        ],
      },
    },
    automaticSystemsDetails: {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.config_gates",
          "tabs.config_gates.automatic_systems",
          "tabs.config_gates.automatic_systems.gate",
        ],
      },
    },
    automaticSystemsOpen: {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.config_gates",
          "tabs.config_gates.automatic_systems",
          "tabs.config_gates.automatic_systems.open",
        ],
      },
    },
    automaticSystemsClose: {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.config_gates",
          "tabs.config_gates.automatic_systems",
          "tabs.config_gates.automatic_systems.close",
        ],
      },
    },
    automaticSystemsEnableEmergency: {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.config_gates",
          "tabs.config_gates.automatic_systems",
          "tabs.config_gates.automatic_systems.emergency",
        ],
      },
    },
    automaticSystemsMode: {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.config_gates",
          "tabs.config_gates.automatic_systems",
          "tabs.config_gates.automatic_systems.mode",
        ],
      },
    },
  },
  alerts: {
    "configOutputs.mail": {
      read: {
        strategy: "allOf",
        perms: [
          "tabs.alerts",
          "tabs.alerts.config_outputs",
          "tabs.alerts.config_outputs.mail",
        ],
      },
    },
  },
};

export default PermissionsConfig;
